import { Component } from '@angular/core';
import { DocumentState } from '@app/core/enums/document/document-state.enum';
import { DocumentType } from '@app/core/enums/document/document-type.enum';
import { CreateDocumentInput } from '@app/core/model/entities/document/document';
import {
  OrganizationDocumentCreateModalComponent
} from '@app/features/main/views/organization-documents/modals/organization-document-create-modal/organization-document-create-modal.component';
import dayjs from 'dayjs';

@Component({
    templateUrl: './work-documents-create-modal.component.html',
    standalone: false
})
export class WorkDocumentsCreateModalComponent extends OrganizationDocumentCreateModalComponent {

  constructor() {
    super();

    // Add columns that are not relevant for a Work's Document
    this.propertiesGridColumnState = [
      {colId: 'defaultSortCol', sort: 'asc'},
      {colId: 'assets', hide: true},
      {colId: 'assetDocumentSection', hide: true},
      {colId: 'documentState', hide: true}
    ];
  }

  /**
   * Create a Document input for each row of the properties grid.
   * @return Document inputs.
   */
  public getCreateDocumentInputs(): CreateDocumentInput[] {
    const documentsToUpdate: CreateDocumentInput[] = [];
    if (this.gridApi) {
      this.gridApi.forEachNode(node => {
        documentsToUpdate.push({
          fileName: node.data.fileName,
          type: DocumentType.DOCUMENT,
          state: DocumentState.ACTIVE,
          name: node.data.document.name,
          entityId: this.uploadData.entityId,
          entityType: this.uploadData.entityType,
          properties: {
            // Use spread to add optional field if condition is fulfilled
            ...(node.data.document.documentCategory && {documentCategory: node.data.document.documentCategory}),
            ...(node.data.document.date && {documentDate: dayjs(node.data.document.date).format(this.appConfig.DATE_FORMAT)}),
            ...(node.data.document.description && {description: node.data.document.description})
          }
        });
      });
    }
    return documentsToUpdate;
  }
}
